
import Group from 'vux/src/components/group/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Marquee from 'vux/src/components/marquee/marquee.vue'
import MarqueeItem from 'vux/src/components/marquee/marquee-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import pkHeader from  './common/header/header.vue';
import Scroll from './common/scroll'

const list = () => ['接站', '送站']
export default {
components: {
Group,
pkHeader,
Swiper,
Marquee,
MarqueeItem,
Tab,
SwiperItem,
TabItem,
Scroll
},
data() {
return {
msg: 'Hello World!',
tabIndex: 0,
show: this.$store.state.mutations.toastshow,
toastMsg: this.$store.state.mutations.toastMsg,
showBack: false,
list: list(),
defaultIndex: this.$store.state.mutations.defaultIndex,
img_list: [],
notices: [{"tile": ""}],
docHeigh:window.innerHeight-42
};
},
watch: {
"tabIndex": function (newValue, oldValue) {
console.log('newValue',newValue);
if (newValue == 0) {
this.$router.push("/pickupStation");
}
if (newValue == 1) {

var newHref =  location.href.indexOf("?") != -1 ? "?"+location.href.substr(location.href.indexOf("?"),location.href.length) : "";
this.$router.push('/giveawayStation'+newHref);
}
if (newValue == 2) {

var newHref =  location.href.indexOf("?") != -1 ? "?"+location.href.substr(location.href.indexOf("?"),location.href.length) : "";
this.$router.push('/pickupAircraft'+newHref);
}
if (newValue == 3) {

var newHref =  location.href.indexOf("?") != -1 ? "?"+location.href.substr(location.href.indexOf("?"),location.href.length) : "";
this.$router.push('/giveawayAircraft'+newHref);
}
},
"$route": function (to, from) {
this.setdefaultIndex(to.path);

localStorage.setItem("quirydate",new Date().format('yyyy-MM-dd'));
localStorage.removeItem("jbStorage");
localStorage.removeItem("$PreDate");
localStorage.removeItem("noTime")
}
},
created() {
this.probeType = 3;
this.listenScroll = true;

},
methods: {
targetHref(item){

location.href = item.url;
},
setdefaultIndex(to){
console.log("to",to);
if (to === "/giveawayStation") {
this.defaultIndex = "送站";
}
if (to === "/pickupStation") {
this.defaultIndex = "接站";
}
if (to === "/pickupAircraft") {
this.defaultIndex = "接机";
}
if (to === "/giveawayAircraft") {
this.defaultIndex = "送机";
}
},
backmethod(){
localStorage.setItem("userMessage","");
localStorage.setItem("cdqcp_conn","");
if("iOS" == localStorage.getItem("appFrom") || "Android" == localStorage.getItem("appFrom")){
location.href = "##backToVC=1";
}else{
if(window.CHANNELTOKEN === 'qdn'){
this.$until.getHomeUrl(this,false);
}else{
location.href="/";
}
}
},
getBanner(){
var that = this;
this.$http.post(window.innerAPI + "?server=initNoticeAndBanner", {}).then(function (res) {
if (res.data) {
var banners = res.data.data.banners;
that.notices = res.data.data.notices;
for (var i  in banners) {
var list_msg = {
url: banners[i].url,
img: banners[i].img,
title: ""
}
that.img_list.push(list_msg);
}

}
}).catch(function (err) {

})
},
},
mounted(){
var that = this;
console.log(this.$route.path);

this.setdefaultIndex(this.$route.path);
this.getBanner();
var appFlag = this.$until.getUrlParam('from');
var newOpenId = this.$until.getUrlParam('openId');
var appToken = this.$until.getUrlParam('token');
if(newOpenId&&newOpenId!=='null'){
window.localStorage.setItem("cdqcp_opid",newOpenId);
window.localStorage.setItem("useCar_cdqcp_opid",newOpenId);
}
(function(m, ei, q, i, a, j, s) {
m[i] = m[i] || function() {
(m[i].a = m[i].a || []).push(arguments)
};
j = ei.createElement(q),
s = ei.getElementsByTagName(q)[0];
j.async = true;
j.charset = 'UTF-8';
j.src = '//static.meiqia.com/dist/meiqia.js';
s.parentNode.insertBefore(j, s);
})(window, document, 'script', '_MEIQIA');
_MEIQIA('entId', 7797);

_MEIQIA('withoutBtn');
}
};



// WEBPACK FOOTER //
// ./src/components/HelloFromVux.vue